import { BaseOwnerEntity } from "../../entity/baseOwnerEntity";

export class CustomerEntity extends BaseOwnerEntity {
  id?: number;
  parentCustomerId?: number;
  storeId?: number;
  customerTypeId?: number;
  isIndividual?: boolean;
  organizationName?: string;
  firstName?: string;
  lastName?: string;
  customerName?: string;
  billingName?: string;
  nationalId?: string;
  taxId?: string;
  taxOffice?: string;
  languageId?: number;
  communityId?: number;
  educationId?: number;
  birthDate?: Date;
  genderId?: number;
  maritalStatusId?: number;
  marriageDate?: Date;
  occupationId?: number;
  sectorId?: number;
  mobilePhone?: string;
  pstnPhone1?: string;
  pstnPhone2?: string;
  email?: string;
  discount?: number;
  cardNumber?: string;
  notes?: string;
  isCurrentAccountUser?: boolean;
  isSmsSend?: boolean;
  isEmailSend?: boolean;
  isBlackList?: boolean;
  isAllowDeliverNotPaid?: boolean;
  revenueScore?: number;
  loyaltyScore?: number;
  isBillingForEachOrder?: boolean;
  showTotalDebtOnReceipt?: boolean;
  showPriceInfoOnReceipt?: boolean;
  isAutoPaymentForCurrentAccount?: boolean;
  discountStartDate?: Date;
  discountEndDate?: Date;
  customerNameSearch?: string;
  firstNameSearch?: string;
  lastNameSearch?: string;
  status?: number;
  bonusId?: number;
  isBonusPassive?: boolean;
  orderInstruction?: string;
  showProductByGroupOnReceipt?: boolean;
  webAccessLink?: string;
  webAccessToken?: string;
  password?: string;
  isVip?: boolean;
  nationalPhone?: string;
  isForeign?: boolean;
  isDisableCalcDiscountSegment?: boolean;
  employeeId?: string;
  isBilling?: boolean;
  billingStartDate?: Date;
  billingProfileId?: string;
  isOnline?: boolean;
  emailForBilling?: string;
  balanceOptionOnReceipt?: string;
  isAddCurrentAccountPaymentToParentCustomer?: boolean;
  externalId?: string;
  smsChannelType?: string;
  customerSourceId?: number;
}